import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {getIosPrice, px} from '../../utils';
import {renderIf} from '../../utils/Utils';

const PriceInfo = ({type, title, unitPrice, totalPrice}) => {
  return (
    <Layout style={styles.container}>
      <View style={styles.priceBox}>
        <View style={styles.block}>
          {renderIf(
            type !== 'Individual',
            <Text style={styles.typeText}>{title}</Text>,
          )}
          {renderIf(
            type === 'Individual',
            <>
              <Text style={styles.typeText}>{type}</Text>

              <Text style={styles.pricepsText}>
                RM {getIosPrice(unitPrice)}/subject
              </Text>
            </>,
          )}
        </View>
        <View style={styles.block}>
          <Text style={styles.totalText}>Total</Text>
          <Text style={styles.priceText}>RM {getIosPrice(totalPrice)}</Text>
        </View>
      </View>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: px(15),
    paddingHorizontal: px(15),
    borderRadius: 10,
    marginTop: px(15),
    marginHorizontal: px(15),
    backgroundColor: '#FFBE0B',
  },
  priceBox: {flexDirection: 'row'},
  block: {
    flex: 1,
  },
  typeText: {fontWeight: '500', fontSize: 16},
  pricepsText: {fontSize: 16, fontWeight: '500'},
  totalText: {fontSize: 16, textAlign: 'right', fontWeight: '500'},
  priceText: {fontWeight: '500', fontSize: 16, textAlign: 'right'},
});

export default PriceInfo;
